import { FC } from 'react';

import { getBannerTextTypography } from 'utils/banner/utils';
import { CampaignSource } from 'utils/constants/campaign';

import { Flex, Text, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { BANNER_SOURCE_ICONS } from 'components/Banners/components/Banner/sourceIcons';

interface BannerSourceLabelProps {
    source: CampaignSource;
}

export const BannerSourceLabel: FC<BannerSourceLabelProps> = ({ source }) => {
    const { isMobile } = useBreakpoint();
    const trls = useTrls();

    const sourceIcon = BANNER_SOURCE_ICONS[source];

    if (!sourceIcon) {
        return null;
    }

    return (
        <Flex gap={6} align="center">
            <img src={sourceIcon.mobile} alt={trls(sourceIcon.label)} />
            <Text typography={getBannerTextTypography(isMobile)}>{trls(sourceIcon.label)}</Text>
        </Flex>
    );
};
